/* eslint-disable no-sparse-arrays */
import React, { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

const publicRoutes = [
  {
    path: "*",
    exact: true,
    component: lazy(() => import("views/core-tnds-xemay/index")),
  },
];

export default function Routes() {
  return (
    <Suspense fallback={<div></div>}>
      <Router>
        <Switch>
          {publicRoutes.map((route, index) => (
            <Route key={index} path={route.path} exact={route.exact}>
              <route.component />
            </Route>
          ))}
        </Switch>
      </Router>
    </Suspense>
  );
}
